module.exports = __webpack_public_path__ + "media/mistake.0d2e22c2.mp3";